/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';

import CurrentUser from 'auth/CurrentUser';
import TriggerComposerButton from './TriggerComposerButton';
import URGENT_MESSAGING_PERMISSION_QUERY from 'chat/queries/UrgentMessagingPermissionQuery.gql';

import type { UrgentMessagingPermission } from 'chat/queries/__generated__/UrgentMessagingPermission';
import type { OrganizationTarget, GroupTarget } from 'entities/Message';

type Props = {
  label?: React.Node,
  className?: string,
  hideAnnouncements?: ?boolean,
  onComposeSelection?: ?Function,
  initialTarget?: ?(GroupTarget | OrganizationTarget),
  data: ReactApolloData<UrgentMessagingPermission>,
};

class TriggerComposerButtonContainer extends React.Component<Props> {
  static defaultProps = {
    label: 'New message',
  };

  canViewUrgentMessaging = () => {
    const currentUser = CurrentUser.getUser();
    const webPermission = currentUser && currentUser.hasFeature('urgent_messaging.web.apr-19');
    const backendPermission = idx(this.props.data, _ => _.me.canSendUrgentMessage);
    return (webPermission && backendPermission) || false;
  };

  currentUserMutedUntil = () => {
    const currentUser = CurrentUser.getUser();
    return currentUser.isMuted() ? currentUser.getMutedUntil() : undefined;
  };

  render() {
    return (
      <TriggerComposerButton
        label={this.props.label}
        className={this.props.className}
        hideAnnouncements={this.props.hideAnnouncements}
        onComposeSelection={this.props.onComposeSelection}
        initialTarget={this.props.initialTarget}
        canViewUrgentMessaging={this.canViewUrgentMessaging()}
        currentUserMutedUntil={this.currentUserMutedUntil()}
      />
    );
  }
}

const withUrgentMessagingPermission = graphql(URGENT_MESSAGING_PERMISSION_QUERY);

export { TriggerComposerButtonContainer };

export default withUrgentMessagingPermission(TriggerComposerButtonContainer);
